'use strict';

var _objectSpread = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/objectSpread2");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _defineProperty = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/defineProperty");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _ReadHandlers;

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

var _require = require('buffer'),
    Buffer = _require.Buffer; // @ts-ignore


var BufferList = require('bl/BufferList');

var varintDecode = require('./varint-decode'); // Maximum length of the length section of the message


var MAX_LENGTH_LENGTH = 8; // Varint.encode(Number.MAX_SAFE_INTEGER).length
// Maximum length of the data section of the message

var MAX_DATA_LENGTH = 1024 * 1024 * 4;
var Empty = Buffer.alloc(0);
var ReadModes = {
  LENGTH: 'readLength',
  DATA: 'readData'
};
var ReadHandlers = (_ReadHandlers = {}, _defineProperty(_ReadHandlers, ReadModes.LENGTH, function (chunk, buffer, state, options) {
  // console.log(ReadModes.LENGTH, chunk.length)
  buffer = buffer.append(chunk);
  var dataLength;

  try {
    dataLength = options.lengthDecoder(buffer);
  } catch (err) {
    if (buffer.length > options.maxLengthLength) {
      throw Object.assign(err, {
        message: 'message length too long',
        code: 'ERR_MSG_LENGTH_TOO_LONG'
      });
    }

    if (err instanceof RangeError) {
      return {
        mode: ReadModes.LENGTH,
        buffer: buffer,
        chunk: undefined,
        state: undefined,
        data: undefined
      };
    }

    throw err;
  }

  if (dataLength > options.maxDataLength) {
    throw Object.assign(new Error('message data too long'), {
      code: 'ERR_MSG_DATA_TOO_LONG'
    });
  }

  chunk = buffer.shallowSlice(options.lengthDecoder.bytes);
  buffer = new BufferList();
  if (options.onLength) options.onLength(dataLength);

  if (dataLength <= 0) {
    if (options.onData) options.onData(Empty);
    return {
      mode: ReadModes.LENGTH,
      chunk: chunk,
      buffer: buffer,
      data: Empty
    };
  }

  return {
    mode: ReadModes.DATA,
    chunk: chunk,
    buffer: buffer,
    state: {
      dataLength: dataLength
    },
    data: undefined
  };
}), _defineProperty(_ReadHandlers, ReadModes.DATA, function (chunk, buffer, state, options) {
  // console.log(ReadModes.DATA, chunk.length)
  buffer = buffer.append(chunk);

  if (!state) {
    throw new Error('state is required');
  }

  if (buffer.length < state.dataLength) {
    return {
      mode: ReadModes.DATA,
      buffer: buffer,
      state: state,
      chunk: undefined,
      data: undefined
    };
  }

  var dataLength = state.dataLength;
  var data = buffer.shallowSlice(0, dataLength);
  var nextChunk = buffer.length > dataLength ? buffer.shallowSlice(dataLength) : undefined;
  buffer = new BufferList();
  if (options.onData) options.onData(data);
  return {
    mode: ReadModes.LENGTH,
    chunk: nextChunk,
    buffer: buffer,
    state: undefined,
    data: data
  };
}), _ReadHandlers);
/**
 * @param {any} [options]
 */

function decode(options) {
  options = options || {};
  /**
   * @type {import('./types').DecoderOptions}
   */

  var opts = {
    lengthDecoder: options.lengthDecoder || varintDecode,
    maxLengthLength: options.maxLengthLength || MAX_LENGTH_LENGTH,
    maxDataLength: options.maxDataLength || MAX_DATA_LENGTH,
    onLength: options.onLength,
    onData: options.onData
  };
  /**
   * @param {AsyncIterable<BufferList>} source
   */

  var decoder = /*#__PURE__*/function () {
    var _ref = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(source) {
      var buffer, mode, state, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, chunk, nextChunk, result;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              buffer = new BufferList();
              mode = ReadModes.LENGTH; // current parsing mode

              // accumulated state for the current mode
              _iteratorAbruptCompletion = false;
              _didIteratorError = false;
              _context.prev = 4;
              _iterator = _asyncIterator(source);

            case 6:
              _context.next = 8;
              return _awaitAsyncGenerator(_iterator.next());

            case 8:
              if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
                _context.next = 25;
                break;
              }

              chunk = _step.value;

              /** @type {BufferList | undefined} */
              nextChunk = chunk; // Each chunk may contain multiple messages - keep calling handler for the
              // current parsing mode until all handlers have consumed the chunk.

            case 11:
              if (!nextChunk) {
                _context.next = 22;
                break;
              }

              result = ReadHandlers[mode](nextChunk, buffer, state, opts);
              mode = result.mode;
              nextChunk = result.chunk;
              buffer = result.buffer;
              state = result.state;

              if (!result.data) {
                _context.next = 20;
                break;
              }

              _context.next = 20;
              return result.data;

            case 20:
              _context.next = 11;
              break;

            case 22:
              _iteratorAbruptCompletion = false;
              _context.next = 6;
              break;

            case 25:
              _context.next = 31;
              break;

            case 27:
              _context.prev = 27;
              _context.t0 = _context["catch"](4);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 31:
              _context.prev = 31;
              _context.prev = 32;

              if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                _context.next = 36;
                break;
              }

              _context.next = 36;
              return _awaitAsyncGenerator(_iterator.return());

            case 36:
              _context.prev = 36;

              if (!_didIteratorError) {
                _context.next = 39;
                break;
              }

              throw _iteratorError;

            case 39:
              return _context.finish(36);

            case 40:
              return _context.finish(31);

            case 41:
              if (!buffer.length) {
                _context.next = 43;
                break;
              }

              throw Object.assign(new Error('unexpected end of input'), {
                code: 'ERR_UNEXPECTED_EOF'
              });

            case 43:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 27, 31, 41], [32,, 36, 40]]);
    }));

    return function decoder(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return decoder;
}
/**
 * @param {*} reader
 * @param {import('./types').DecoderOptions} [options]
 * @returns
 */


decode.fromReader = function (reader, options) {
  var _varByteSource;

  var byteLength = 1; // Read single byte chunks until the length is known

  var varByteSource = (_varByteSource = {}, _defineProperty(_varByteSource, Symbol.asyncIterator, function () {
    return this;
  }), _defineProperty(_varByteSource, "next", function () {
    var _next = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return reader.next(byteLength);

            case 3:
              return _context2.abrupt("return", _context2.sent);

            case 6:
              _context2.prev = 6;
              _context2.t0 = _context2["catch"](0);

              if (!(_context2.t0.code === 'ERR_UNDER_READ')) {
                _context2.next = 10;
                break;
              }

              return _context2.abrupt("return", {
                done: true,
                value: null
              });

            case 10:
              throw _context2.t0;

            case 11:
              _context2.prev = 11;
              // Reset the byteLength so we continue to check for varints
              byteLength = 1;
              return _context2.finish(11);

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 6, 11, 14]]);
    }));

    function next() {
      return _next.apply(this, arguments);
    }

    return next;
  }()), _varByteSource);
  /**
   * Once the length has been parsed, read chunk for that length
   *
   * @param {number} l
   */

  var onLength = function onLength(l) {
    byteLength = l;
  };

  return decode(_objectSpread(_objectSpread({}, options || {}), {}, {
    onLength: onLength
  }))(varByteSource);
};

module.exports = decode;
module.exports.MAX_LENGTH_LENGTH = MAX_LENGTH_LENGTH;
module.exports.MAX_DATA_LENGTH = MAX_DATA_LENGTH;